// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3Jlik","subheader":"ReorderModal_subheader__1VM0d","listWrap":"ReorderModal_listWrap__2T1HR"};